import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: ${({ width, maxWidth }) => width && `min(${width}, ${maxWidth})`};
  margin: 0 auto;
  padding-bottom: 10rem;
  padding-bottom: min(10rem, 10vw, 10%);
`;
